const DEBUG_MODE = false; // 🔥 设置为 false 关闭所有 console.log()
 
$(document).ready(function () {
    const $scope = $('.halo-productView');
    const sliderNav = $scope.find('.productView-nav');
    const sliderFor = $scope.find('.productView-for');

    if (!sliderNav.length || !sliderFor.length) {
        debugLog("ev-❌ 轮播未找到，无法监听变化", "error");
        return;
    }  

    debugLog("ev-✅ 轮播初始化成功，监听变体切换中...");

    // ✅ 页面加载时初始化过滤
    const initialFilterValue = getSelectedFilter();
    debugLog("ev-🎯 初始筛选条件:", initialFilterValue);
    if (initialFilterValue) {
        filterGalleryImages(initialFilterValue);
    }

    // ✅ 监听 `data-value-default-lang` 变化
    const observer = new MutationObserver(() => {
        let newFilterValue = getSelectedFilter();
        debugLog("ev-🔄 `data-value-default-lang` 变化，更新筛选条件:", newFilterValue);
        filterGalleryImages(newFilterValue);
    });

    document.querySelectorAll('input[type="radio"]').forEach(radio => {
        observer.observe(radio, { attributes: true, attributeFilter: ['data-value-default-lang'] });
    });

    // ✅ 监听 `variantMediaChange` 事件
    window.addEventListener("variantMediaChange", (event) => {
        let newFilterValue = getSelectedFilter();
        debugLog("ev-📸 `variantMediaChange` 触发，变体:", event.detail);
        filterGalleryImages(newFilterValue, event.detail.mediaId);
    });
});

// ✅ 获取当前选中的 `data-filter`
function getSelectedFilter() {
    return $('input[type="radio"]:checked').map(function () {
        return $(this).attr('data-filter');
    }).get().join(",");
}




function filterGalleryImages(filterValue, mediaId = null) {
    const sliderNav = $('.productView-nav');
    const slidersFor = $('.productView-for');  // 查找所有 sliderFor 元素

    if (!sliderNav.length || !slidersFor.length) {
        debugLog("ev-❌ 轮播未找到，无法应用过滤", "error");
        return;
    }

    const currentFilter = slidersFor.attr('data-current-filter');
    
    // **🔹 过滤值为空时，显示所有图片**
    if (!filterValue) {
        debugLog("ev-🔄 没有筛选条件，显示所有图片");
        filterValue = ".filter-all"; // 让 Slick 显示全部图片
    }

    // **🔹 筛选值未变更时，跳过**
    if (currentFilter === filterValue) {
        debugLog("ev-⚠️ 筛选条件未变更，跳过过滤:", filterValue);
        return;
    }

    slidersFor.attr('data-current-filter', filterValue);
    sliderNav.attr('data-current-filter', filterValue);

    let filterClasses = formatFilterClasses(filterValue);
    debugLog("ev-🛠 过滤 `Slick` 轮播，筛选条件:", filterClasses);

    waitForSlickInit(slidersFor, () => {
        // **🔹 处理过滤条件并应用 OR 筛选**
        const filterArray = processFilterClasses(filterClasses);
        debugLog("ev-filterArray", filterArray);  // 查看过滤条件

        // **🔹 先清除之前的过滤结果，然后应用新筛选**
        slidersFor.slick('slickUnfilter');  // 清除先前的筛选
        sliderNav.slick('slickUnfilter');   // 清除 sliderNav 的筛选

        // **🔹 应用 OR 筛选：每个元素需要包含任意筛选条件类**
        slidersFor.each(function() {
            const sliderFor = $(this); // 遍历每个 sliderFor
            let filteredSlides = filterSlides(sliderFor, filterArray, '.productView-thumbnail');

            debugLog("ev-filteredSlides for", filteredSlides);  // 查看筛选结果

            // 执行过滤
            sliderFor.slick('slickFilter', filteredSlides).slick('refresh');
        });

        // 对 sliderNav 进行筛选
        sliderNav.each(function() {
            const nav = $(this); // 遍历每个 sliderNav
            let filteredNavItems = filterSlides(nav, filterArray, '.productView-image');

            debugLog("ev-filteredNavItems", filteredNavItems);  // 查看筛选结果

            // 执行过滤
            nav.slick('slickFilter', filteredNavItems).slick('refresh');
        });

        if (mediaId) {
            debugLog("ev-🎯 变体图片 ID:", mediaId, "执行跳转...");
            setTimeout(() => {
                scrollToVariantMedia(mediaId);
            }, 1000);
        }
    });
}

// **🔹 处理筛选类名，去除前导点 (.)**
function processFilterClasses(filterClasses) {
    let filterArray = filterClasses.split(',').map(item => item.trim());
    // 去掉 `.` 前缀
    return filterArray.map(item => item.startsWith('.') ? item.slice(1) : item);
}

// **🔹 筛选符合条件的轮播项（OR 筛选）**
function filterSlides(slider, filterArray, itemClass) {
    debugLog("ev-filterArray", filterArray);  // 查看 filterArray 的内容

    return slider.find(itemClass).filter(function() {
        const slide = $(this);
        const slideClasses = slide.attr('class').split(' '); // 获取该项的所有类
        const filterClasses = slideClasses.filter(item => item.startsWith("filter-")); // 仅筛选出以 'filter-' 开头的类
        
        debugLog("ev-filterClasses", filterClasses);  // 查看每个 slide 的 'filter-' 类名

        // 检查 slide 中是否有 filterArray 中的任何类
        const isValidSlide = filterClasses.every(cls => filterArray.includes(cls));

        return isValidSlide;
    });
}












// ✅ 轮播跳转到指定变体图片
function scrollToVariantMedia(mediaId) {
    if (!mediaId) {
        debugLog("ev-⚠️ `mediaId` 为空，跳过滚动", "warn");
        return;
    }

    const sliderFor = $('.productView-for');
    const slickInstance = sliderFor.slick('getSlick');

    if (!slickInstance) {
        debugLog("ev-❌ `Slick` 轮播未初始化，无法滚动到变体", "error");
        return;
    } 

    let targetIndex = null;
    slickInstance.$slides.each((index, slide) => {
        if ($(slide).attr('data-media-id')?.includes(mediaId)) {
            targetIndex = index;
            return false;
        }
    });

    if (targetIndex !== null) {
        debugLog("ev-🔄 滚动到 `Slick` 轮播索引:", targetIndex);
        sliderFor.slick("slickGoTo", targetIndex);
    } else {
        debugLog("ev-⚠️ 未找到 `mediaId` 对应的轮播项:", mediaId, "warn");
    }
}

// ✅ 格式化 `filterClasses`
function formatFilterClasses(filterValue) {
    let filterValues = filterValue.split(",").map(value => value.trim()).filter(Boolean);
    filterValues.push(".filter-all");

    return filterValues.map(value => 
        value.startsWith(".filter-") ? value : `.filter-${value}`
    ).join(",");
}

// ✅ 等待 `Slick` 初始化
function waitForSlickInit(sliders, callback) {

    // 遍历所有的 slider 元素
    sliders.each(function() {
        const slider = $(this);

        if (slider.hasClass('slick-initialized')) {
            debugLog("ev-✅ `Slick` 轮播已初始化，执行回调");
            callback(slider); // 如果找到初始化的 slider，立即执行回调
            return false; // 结束 .each() 遍历，找到第一个已初始化的元素后就不继续遍历
        }
    });

    // 如果没有找到初始化的 slider，定时检查
    let checkSlick = setInterval(() => {
        debugLog("ev-✅ `Slick`检查中");

        sliders.each(function() {
            const slider = $(this);
            if (slider.hasClass('slick-initialized')) {
                clearInterval(checkSlick); // 轮询结束
                debugLog("ev-✅ `Slick` 轮播初始化完成，执行回调");
                callback(slider); // 执行回调
                return false; // 找到一个已初始化的 slider 后跳出循环
            }
        });
    }, 1000);
}


// ✅ 统一 `console.log()`，通过 `DEBUG_MODE` 控制
function debugLog(message, ...optionalParams) {
    if (DEBUG_MODE) {
        console.log(message, ...optionalParams);
    }
}
